/** Deve coincidir com functions/legal/termosConsultaMaisV1.js (TERMS_OF_USE_VERSION). */
export const TERMS_OF_USE_VERSION = '2.39';
